import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ErrorIntercepterService implements HttpInterceptor {

  constructor(private matSnackBar: MatSnackBar) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
              let errorMessage = 'An Unknown Error Occurred!';
              if (error.error) {
                  errorMessage = error.error;
              }
              this.matSnackBar.open(errorMessage, 'OK', { duration: 3000 });
              return throwError(error);
          })
      );
  }
}
